import { DialogActions, DialogContent, Grid } from '@mui/material'
import { useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TabPanel from '../../../../shared/components/TabPanel'
import { CancelButton, SaveButton } from '../../../../shared/components/inputs'
import { formsStyles } from '../../../../shared/styles/FormsStyles'
import { useSeminarModal } from '../hooks/useSeminarModal'
import { AddonsTab } from './modal/AddonsTab'
import { BasicForm } from './modal/BasicForm'
import { GeneralTab } from './modal/GeneralTab'
import { ModalHeader } from './modal/ModalHeader'
import useTabState from '@/contexts/shared/hooks/useTabState'
import { StyledTabs } from '@/contexts/shared/components/StyledTabs'
import { CustomTab } from '@/contexts/backoffice/users/ui/components/modals/create/CustomTab'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'
import { useSelector } from 'react-redux'
import { IRootState } from '@/redux/types'

function SeminarModal() {
  const theme = useTheme()
  const formClasses = formsStyles(theme)
  const { t } = useTranslation(['global'])
  const { currentTab, setCurrentTab, a11yProps } = useTabState()

  const { showForm } = useSelector((state: IRootState) => state.seminar)
  const { errorTab, msgForm, isValidForm } = useSelector((state: IRootState) => state.validator)
  const { seminarState, handleInputChange, handleSubmit, handleCloseModal, VISIBILITY, STATUS } = useSeminarModal()

  return (
    <StyledDialog
      open={showForm}
      onClose={handleCloseModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <ModalHeader isEditing={seminarState.id !== null} onClose={handleCloseModal} />

      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <BasicForm seminarState={seminarState} handleInputChange={handleInputChange} />
        <Grid item xs={12}>
          <StyledTabs value={currentTab} onChange={(_, value) => setCurrentTab(value)} aria-label="disabled tabs example">
            <CustomTab label={t('general')} {...a11yProps(0)} error={errorTab.general} />
            <CustomTab label={t('add-ons')} {...a11yProps(1)} error={errorTab.addOn} />
          </StyledTabs>
        </Grid>
        <TabPanel value={currentTab} index={0}>
          <GeneralTab VISIBILITY={VISIBILITY} STATUS={STATUS} seminarState={seminarState} handleInputChange={handleInputChange} />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <AddonsTab
            novelty={seminarState.novelty}
            cover={seminarState.cover}
            handleInputChange={handleInputChange}
          />
        </TabPanel>
      </DialogContent>
      <DialogActions className={!isValidForm && Object.keys(msgForm).length > 0 ? String(formClasses.errorDialogActions) : ''}>
        <CancelButton onClick={handleCloseModal}>{t('cancel')}</CancelButton>
        <SaveButton autoFocus data-createseminar="saveButton" onClick={handleSubmit}>
          {t('save')}
        </SaveButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default SeminarModal
